import { render, staticRenderFns } from "./SearchResultsModal.vue?vue&type=template&id=ebfbabfc&"
import script from "./SearchResultsModal.vue?vue&type=script&lang=js&"
export * from "./SearchResultsModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsModal.vue?vue&type=style&index=0&id=ebfbabfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports